import { Button, Grid, Input, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { Field, Form } from 'react-final-form'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TextFieldCustom } from '../../components/FormElements';
import { config_path } from '../../router/config.path';
import validators from '../../utils/validators';
import Container from '../../components/Container';
import PublicPage from '../PublicPage';

export default function ForgotPasswordView(props) {
    const { message } = props;
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <PublicPage message={message} showProcessing={props.showProcessing} confirm={props.confirm}>
            <Grid item xs={12} marginTop={4}>
                <Typography variant='h4' textAlign={'center'}>{t('forgot_password')}</Typography>
            </Grid>
            <Grid item xs={12} marginTop={4}>
                <Grid item xs={12}>
                    <Form
                        onSubmit={props.onSubmit}
                        render={({ handleSubmit }) => (
                            <Grid xs={12} container item>
                                <Grid item xs={12} marginY={2}>
                                    <Field
                                        name="email"
                                        component={TextFieldCustom}
                                        label={t('email')}
                                        placeholder={t('enter_email')}
                                        isEdit={true}
                                        color='default'
                                        validate={validators.composeValidators(validators.validEmail)}
                                        autoFocus={true}
                                    />
                                </Grid>
                                <Grid xs={12} item container marginTop={2}>
                                    <Button variant="contained" fullWidth onClick={handleSubmit}>{t('btn_submit')}</Button>
                                </Grid>
                            </Grid>
                        )}
                    />
                    <Grid item xs={12} container justifyContent={'center'} marginTop={2}>
                        <Button onClick={() => navigate(config_path.login)} variant='text'>{t('btn_login')}</Button>
                    </Grid>
                </Grid>
            </Grid>
        </PublicPage>
    )
}
